import apiClient from '../lib/api-client';

export interface RegisterDto {
  email: string;
  password: string;
  name: string;
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    emailVerified?: boolean;
  };
}

export const authService = {
  async register(data: RegisterDto) {
    const response = await apiClient.post<AuthResponse>('/auth/register', data);
    if (response.data.accessToken) {
      apiClient.setTokens(
        response.data.accessToken,
        response.data.refreshToken
      );
    }
    return response.data;
  },

  async login(data: LoginDto) {
    const response = await apiClient.post<AuthResponse>('/auth/login', data);
    if (response.data.accessToken) {
      apiClient.setTokens(
        response.data.accessToken,
        response.data.refreshToken
      );
    }
    return response.data;
  },

  async logout() {
    try {
      await apiClient.post('/auth/logout');
    } finally {
      apiClient.logout();
      window.location.href = '/login';
    }
  },

  async refreshToken(refreshToken: string) {
    const response = await apiClient.post<{ accessToken: string }>(
      '/auth/refresh',
      { refreshToken }
    );
    return response.data;
  },

  async requestPasswordReset(email: string) {
    const response = await apiClient.post<{ message: string }>(
      '/auth/password/request',
      { email }
    );
    return response.data;
  },

  async resetPassword(token: string, newPassword: string) {
    const response = await apiClient.post<{ message: string }>(
      '/auth/password/reset',
      { token, newPassword }
    );
    return response.data;
  },
};
